import { DocumentApi } from '../test-api/index.ts'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
const documentApi = new DocumentApi({}, '/api/v2')
import handleApiError from '../utils/handleApiError'

export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async addDocument(name, files) {
      this.loading = true
      const bcFolderStore = useBcFolderStore()
      const bcDocumentStore = useBcDocumentStore()
      if (name === undefined) {
        name = this.$t('New document')
      }

      const response = await handleApiError(() => documentApi.documentCreate({
        name,
        rank: bcFolderStore.listChildren[bcFolderStore.current.id] ? bcFolderStore.listChildren[bcFolderStore.current.id].length : 0,
        bc_folder_id: bcFolderStore.current.id,
        files_ids: files
      }))

      bcFolderStore.updateDocument(response.data)
      const url = new URL(response.data.url)
      bcDocumentStore.willLoadInEdit = true
      bcDocumentStore.isNewDocument = true
      bcDocumentStore.document = {}
      await this.$router.push(url.pathname)
      this.loading = false
    }
  }
}